export default __webpack_public_path__ + "static/media/Ts_2020-1-1.67ca9cff.png";